module.exports = __webpack_public_path__ + "static/media/IFG_Closing_Ceremony_Poster.c572b290.jpg";